import { PropsWithChildren } from 'react';

import { Icon, IconType } from '@shared/ui/components/Icon';

type GlobalSearchResultProps = PropsWithChildren<{
  icon: IconType;
}>;

export function GlobalSearchResult({ icon, children }: GlobalSearchResultProps) {
  return (
    <span className="flex">
      <Icon icon={icon} className="w-6 mt-1" />
      <span className="flex-1">{children}</span>
    </span>
  );
}
